import { render } from "./PlusMinus.vue?vue&type=template&id=0dd71261&scoped=true"
import script from "./PlusMinus.vue?vue&type=script&lang=js"
export * from "./PlusMinus.vue?vue&type=script&lang=js"

import "./PlusMinus.vue?vue&type=style&index=0&id=0dd71261&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd71261"]])

export default __exports__